import {
  Car,
  Gauge,
  HeartPulse,
  IdCard,
  KeyRound,
  Leaf,
  Route,
  Scale,
  ShieldCheck,
  Signpost,
  Users,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import type { RoadCodeThemeKey } from '../../lib/roadCode';

// Icône et teinte de chaque thème officiel : teintes d'accompagnement de la charte (palette Tailwind).

export const THEME_VISUALS: Record<RoadCodeThemeKey, { icon: LucideIcon; tile: string }> = {
  circulation: { icon: Signpost, tile: 'bg-primary-50 text-primary-600' },
  conducteur: { icon: IdCard, tile: 'bg-blue-100 text-blue-800' },
  route: { icon: Route, tile: 'bg-amber-100 text-amber-700' },
  usagers: { icon: Users, tile: 'bg-violet-100 text-violet-700' },
  notions: { icon: Scale, tile: 'bg-slate-100 text-slate-700' },
  secours: { icon: HeartPulse, tile: 'bg-danger-light text-danger-dark' },
  vehicule: { icon: KeyRound, tile: 'bg-emerald-50 text-emerald-700' },
  mecanique: { icon: Wrench, tile: 'bg-orange-100 text-orange-700' },
  securite: { icon: ShieldCheck, tile: 'bg-sky-100 text-sky-800' },
  environnement: { icon: Leaf, tile: 'bg-success-light text-success-dark' },
};

/** Icône d'une série sans thème (entraînement, examen blanc, erreurs). */
export const MODE_ICONS = { training: Gauge, exam: Car } as const;
